export * from './roof-type-6.component';